export default defineNuxtRouteMiddleware(async (to) => {
	const localePath = useLocalePath()
	const newsID = to.params.newsID
	const localeLang = usei18nService()?.getLocaleLang()
	const newsService = useNewsService()
	if (!to.params.newsTitle) {
		throw createError({ statusCode: 404 })
	}
	const redirection = newsRedirections.find((redirection) => Number(redirection.fromID) === Number(to.params.newsID))
	if (redirection) {
		return navigateTo(localePath(redirection.toRoute), { redirectCode: 301 })
	}
	try {
		const post = await ApiService.fetchSingleNews(newsID, localeLang)
		if (newsService.getNewsName(post.title) !== to.params.newsTitle[0]) {
			return navigateTo(localePath({ name: 'news-newsID-newsTitle', params: { newsID, newsTitle: newsService.getNewsName(post.title) } }), {
				redirectCode: 301,
			})
		}
	} catch (error) {
		return navigateTo(localePath('/'), { redirectCode: 301 })
	}
})
